import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class UsersLogAPI {
  private static readonly API_URL = "/users_log";

  static async getUserLog(userId: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.get(`${UsersLogAPI.API_URL}/${userId}`, true);
    }, "Error al obtener el historial de los usuarios");
  }
}
